import {
  formatWorkflowAmount,
  formatWorkflowDate,
} from "./workflows/figures.js"

/* A table item's columns are names only; nothing says which one holds a
   date or money. Until they carry a type, the column's own name decides how
   its cells are typed and shown, so "2026-09-08" reads as a date and
   "389.99" as $389.99 in the mono face, right-aligned (R9-U5). */

export type PortalTableColumnKind = "date" | "money" | "text"

const dateWords = /\b(date|day|when)\b/i
const moneyWords =
  /\b(cost|costs|amount|price|total|paid|value|balance|fee|fees|payment|spent)\b|\$/i

/** How a column's cells are typed and shown, read from its name. */
export const portalTableColumnKind = (column: string): PortalTableColumnKind =>
  dateWords.test(column)
    ? "date"
    : moneyWords.test(column)
      ? "money"
      : "text"

/** One cell as the firm reads it. A value that does not fit its column's
 * kind is shown as typed. */
export const formatPortalTableCell = (
  column: string,
  value: string
): string => {
  const kind = portalTableColumnKind(column)
  const trimmed = value.trim()
  if (!trimmed) return ""
  if (kind === "date") return formatWorkflowDate(trimmed) ?? trimmed
  if (kind === "money") {
    const plain = trimmed.replace(/[$,\s]/g, "")
    return /^-?\d+(\.\d+)?$/.test(plain)
      ? (formatWorkflowAmount(plain, "USD") ?? trimmed)
      : trimmed
  }
  return trimmed
}
